export enum SupportLanguages {
  Chinese = "zh",
  Chinese_Traditional = "zh-HK", // 2022-11-28 新增语言
  English = "en",
  French = "fr",
  German = "de",
  Italian = "it",
  Spanish = "es",
  // Danish = 'da',
  Portuguese_Portugal = "pt",
  Dutch = "nl", // 2022-11-28 新增语言
  Swedish = "sv", // 2022-11-28 新增语言

  // 2023-11-28 新增语言
  Danish = "da",
  Czech = "cs",
  Norwegian = "no",
  Norwegian_Bokmal = "nb",
  Polish = "pl",
  Finnish = "fi",
  Turkish = "tr",
  Thai = "th",
  Japanese = "ja",
  Korean = "ko",
  Portuguese_Brazil = "pt-BR",
}

/**
 * 判断字符值是否是支持的语言
 * @param value - 需要判断的字符值
 * @returns 是否支持
 */
export function isSupportedLanguage(value: string): boolean {
  return Object.values(SupportLanguages).includes(value)
}
